import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiTwitter, FiLinkedin, FiInstagram, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-emerald-800 to-emerald-900 text-white mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-amber-500 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-xl">🌾</span>
              </div>
              <div>
                <h2 className="text-2xl font-bold">DAN</h2>
                <p className="text-emerald-200 text-sm">Decentralized Agribusiness Network</p>
              </div>
            </div>
            <p className="text-emerald-200 mb-6">
              Connecting farmers and traders worldwide with secure, AI-powered agricultural trading.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-full bg-emerald-700 hover:bg-emerald-600 flex items-center justify-center transition-colors">
                <FiFacebook />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-emerald-700 hover:bg-emerald-600 flex items-center justify-center transition-colors">
                <FiTwitter />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-emerald-700 hover:bg-emerald-600 flex items-center justify-center transition-colors">
                <FiLinkedin />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-emerald-700 hover:bg-emerald-600 flex items-center justify-center transition-colors">
                <FiInstagram />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-emerald-200 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/marketplace" className="text-emerald-200 hover:text-white transition-colors">Marketplace</Link></li>
              <li><Link to="/education-hub" className="text-emerald-200 hover:text-white transition-colors">Education Hub</Link></li>
              <li><Link to="/about" className="text-emerald-200 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-emerald-200 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Legal</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-emerald-200 hover:text-white transition-colors">Terms of Service</a></li>
              <li><a href="#" className="text-emerald-200 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="text-emerald-200 hover:text-white transition-colors">Cookie Policy</a></li>
              <li><a href="#" className="text-emerald-200 hover:text-white transition-colors">KYC Policy</a></li>
              <li><a href="#" className="text-emerald-200 hover:text-white transition-colors">Trading Rules</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-center">
                <FiMail className="w-5 h-5 text-amber-400 mr-3" />
                <span className="text-emerald-200">support@DAN.com</span>
              </li>
              <li className="flex items-center">
                <FiPhone className="w-5 h-5 text-amber-400 mr-3" />
                <span className="text-emerald-200">+(234) 8109199316</span>
              </li>
              <li className="flex items-center">
                <FiMapPin className="w-5 h-5 text-amber-400 mr-3" />
                <span className="text-emerald-200">123 Hotoro Kano Nigeria</span>
              </li>
            </ul>
            <div className="mt-8">
              <h4 className="font-bold mb-3">Newsletter</h4>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-4 py-2 rounded-l-lg text-emerald-900 outline-none"
                />
                <button className="btn-secondary rounded-l-none px-4">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-emerald-700 mt-12 pt-8 text-center">
          <p className="text-emerald-200">
            © {new Date().getFullYear()} Decentralized Agribusiness Network (DAN). All rights reserved. | 
            Built with ❤️ for the agricultural community
          </p>
          <div className="mt-4 flex flex-wrap justify-center gap-4 text-sm text-emerald-300">
            <span>🌍 Available in 5+ languages</span>
            <span>💱 8+ currencies supported</span>
            <span>🔒 Bank-level security</span>
            <span>🤖 AI-powered verification</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;